import {createRouter, createWebHashHistory, RouteRecordRaw} from 'vue-router'

import {getToken} from '@/utils/cache'

import Home from '@/views/Home.vue'
import NotFound from '@/views/404.vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/home',
        component: Home,
        meta: {title: '主页'},
        children: [
            {
                path: '/project/index',
                component: () => import("@/views/project/Index.vue")
            },
            {
                path: '/event-list/index',
                component: () => import("@/views/event-list/Index.vue")
            },
            {
                path: '/my/index',
                component: () => import("@/views/my/My.vue")
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import("@/views/Login.vue")
    },
    {
        path: '/home',
        name: 'home',
        component: () => import("@/views/Home.vue")
    },
    {
        path: '/change/index',
        name: 'change',
        component: () => import("@/views/change/Index.vue")
    },
    {
        path: '/register/index',
        name: 'register',
        component: () => import("@/views/register/Index.vue")
    },
    {
        path: '/my/setting/index',
        name: 'setting',
        component: () => import("@/views/my/setting/Index.vue")
    },
    {
        path: '/my/info/index',
        name: 'info',
        component: () => import("@/views/my/info/Index.vue")
    },
    {
        path: '/my/info/edit',
        name: 'edit',
        component: () => import("@/views/my/info/edit/Index.vue")
    },
    {
        path: '/project/business-form/index',
        name: 'BusinessForm',
        component: () => import("@/views/project/business-form/Index.vue")
    },
    {
        path: '/event-list/history-info/index',
        name: 'historyInfo',
        component: () => import("@/views/event-list/history-info/Index.vue")
    },
    {
        path: '/wechat/wechatBind',
        name: 'WechatBind',
        component: () => import("@/views/wechat/Index.vue")
    },
    {
        path: '/:pathMatch(.*)',
        name: 'NotFound',
        component: NotFound
    },
    {
        path: '/map',
        name: 'GDMap',
        component: () => import("@/views/map/MapContainer.vue")
    },
    {
        path: '/tips/helpline',
        name: 'helpline',
        component: () => import("@/views/tips/helpline/Index.vue")
    },
    {
        path: '/tips/psychServices',
        name: 'psychServices',
        component: () => import("@/views/tips/psychServices/Index.vue")
    },
    {
        path: '/recorder/index',
        name: 'recorder',
        component: () => import("@/views/recorder/RecorderView.vue")
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

function routerExists(to: any): boolean {
    return routes.some((route) => route.path === to.path)
}

const whiteLists = [
    "/change/index",
    "/register/index",
    "/wechat/wechatBind",
    "/tips/helpline",
    "/tips/psychServices",
]

function onWhiteList(to: any): boolean {
    return whiteLists.includes(to.path)
}

router.beforeEach((to, from, next) => {
    const token = getToken();
    const redirectsRouter = to.query.redirectsRouter as string || '';

    if (!routerExists(to)) {
        next()
    } else if (to.path === "/login") {
        if (token) {
            if (redirectsRouter) {
                // 有 redirectsRouter，优先跳转
                router.push(redirectsRouter)
                return; // 记得 return，避免后面继续执行 next
            } else {
                next({path: "/", query: to.query});
            }
        } else {
            next();
        }
    } else {
        if (!token) {
            if (onWhiteList(to)) {
                next()
            } else {
                next({path: "/login", query: to.query});
            }
        } else {
            next();
        }
    }

})

export default router
